// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.field {
    background: #FFFFFF;
    border: 1px solid #D9D9D9 !important;
    border-radius: 10px !important;
    height: 50px !important;
  }
  
  .small-text {
    color:#949494;
    font-size: 15px;
    line-height: 18.75px;
    font-weight: 300;
  }
.btn-custom{
    background: #d74848 !important;
    border-radius: 10px !important;
    font-weight: 500 !important;
    text-transform: capitalize !important;
    border: none;
    outline: none !important;
    padding: .7rem 1rem;
    color: #ffffff;
    font-family: "Lexend", sans-serif !important;
  }

  .has-search .form-control {
    padding-left: 2.375rem;
  }
  
  .has-search .form-control-feedback {
    position: absolute;
    z-index: 2;
    display: block;
    width: 2.375rem;
    height: 2.375rem;
    line-height: 2.375rem;
    text-align: center;
    pointer-events: none;
    color: #aaa;
  }
  
  .dropdown-content {
    position: absolute;
    background-color: #ffffff;
    min-width: 160px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
    
  }

  .dropdown-content ul{
    padding-inline-start: 0 !important;
    max-height: 200px;
    overflow-y: auto;
    overscroll-behavior: contain;
  }

  .dropdown-content li{
    list-style: none;
    cursor: pointer;
  }

  .dropdown-content li:hover {background-color: #ddd;}

  .disabled{
    pointer-events: none;
    opacity: 0.7;
    color:  rgb(170, 170, 170);
  }

  .dark{
    background: #585858;
    border: 1px solid #585858;
    color: #C4C4C4;
  }
  p{
    font-size: 12px;
  }

  li{
    font-size: 12px;
  }`, "",{"version":3,"sources":["webpack://./src/app/shared/components/searchable-dropdown/searchable-dropdown.component.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,oCAAoC;IACpC,8BAA8B;IAC9B,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,oBAAoB;IACpB,gBAAgB;EAClB;AACF;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,2BAA2B;IAC3B,qCAAqC;IACrC,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;IACd,4CAA4C;EAC9C;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,4CAA4C;IAC5C,UAAU;;EAEZ;;EAEA;IACE,kCAAkC;IAClC,iBAAiB;IACjB,gBAAgB;IAChB,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA,4BAA4B,sBAAsB,CAAC;;EAEnD;IACE,oBAAoB;IACpB,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;EAChB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB","sourcesContent":["\n.field {\n    background: #FFFFFF;\n    border: 1px solid #D9D9D9 !important;\n    border-radius: 10px !important;\n    height: 50px !important;\n  }\n  \n  .small-text {\n    color:#949494;\n    font-size: 15px;\n    line-height: 18.75px;\n    font-weight: 300;\n  }\n.btn-custom{\n    background: #d74848 !important;\n    border-radius: 10px !important;\n    font-weight: 500 !important;\n    text-transform: capitalize !important;\n    border: none;\n    outline: none !important;\n    padding: .7rem 1rem;\n    color: #ffffff;\n    font-family: \"Lexend\", sans-serif !important;\n  }\n\n  .has-search .form-control {\n    padding-left: 2.375rem;\n  }\n  \n  .has-search .form-control-feedback {\n    position: absolute;\n    z-index: 2;\n    display: block;\n    width: 2.375rem;\n    height: 2.375rem;\n    line-height: 2.375rem;\n    text-align: center;\n    pointer-events: none;\n    color: #aaa;\n  }\n  \n  .dropdown-content {\n    position: absolute;\n    background-color: #ffffff;\n    min-width: 160px;\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n    z-index: 1;\n    \n  }\n\n  .dropdown-content ul{\n    padding-inline-start: 0 !important;\n    max-height: 200px;\n    overflow-y: auto;\n    overscroll-behavior: contain;\n  }\n\n  .dropdown-content li{\n    list-style: none;\n    cursor: pointer;\n  }\n\n  .dropdown-content li:hover {background-color: #ddd;}\n\n  .disabled{\n    pointer-events: none;\n    opacity: 0.7;\n    color:  rgb(170, 170, 170);\n  }\n\n  .dark{\n    background: #585858;\n    border: 1px solid #585858;\n    color: #C4C4C4;\n  }\n  p{\n    font-size: 12px;\n  }\n\n  li{\n    font-size: 12px;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
